import { difference } from 'lodash';

const arrayDirtyValues = (initialValues, values, key) => {
  const initialArray = initialValues[key];
  const addedToArray = difference(values[key], initialArray);
  const deletedFromArray = difference(initialArray, values[key]);

  const added = addedToArray.filter(({ id }) => id < 0).map((item) => ({ ...item, id: undefined }));

  const edited = addedToArray.filter(({ id }) => id > 0);

  const editedIds = edited.map(({ id }) => id);

  const deleted = deletedFromArray.filter(({ id }) => id && !editedIds.includes(id)).map(({ id }) => id);

  return { added, edited, deleted };
};

export default arrayDirtyValues;
